export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"screen-orientation","content":"portrait-primary"},{"name":"msapplication-TileColor","content":""},{"name":"msapplication-config","content":"/images/icon/browserconfig.xml"},{"name":"theme-color","content":""},{"name":"description","content":"Byt elavtal. 100% Kärnkraft. 0% Klimatångest. El till lågt pris. 7,7% billigare än genomsnittet."},{"name":"twitter:domain","content":"https://karnkraft.se/"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"Svensk Kärnkraft AB"},{"name":"twitter:url","content":"https://karnkraft.se"},{"name":"twitter:description","content":"Byt elbolag – bota din klimatångest med 100% svensk kärnkraft."},{"name":"twitter:image","content":"https://karnkraft.se/images/icon/impala_tw.jpg"},{"http-equiv":"ScreenOrientation","content":"autoRotate:disabled"},{"name":"twitter:image:alt","content":"Svensk Kärnkraft AB logo"},{"name":"twitter:site","content":"@KarnkraftSe"},{"property":"og:title","content":"Svensk Kärnkraft AB"},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://karnkraft.se"},{"property":"og:description","content":"Byt elbolag – bota din klimatångest med 100% svensk kärnkraft."},{"property":"og:image","content":"https://karnkraft.se/images/icon/impala_tw.jpg"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:image:alt","content":"Svensk Kärnkraft AB logo"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/images/icon/apple-touch-icon.png?v=1"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/images/icon/favicon-32x32.png?v=1"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/images/icon/favicon-16x16.png?v=1"},{"rel":"mask-icon","href":"/images/icon/safari-pinned-tab.svg?v=1?v=1"},{"rel":"shortcut icon","href":"/images/icon/favicon.ico?v=1"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":true},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Blinker:wght@300;600;800&display=swap"}],"style":[],"script":[],"noscript":[{"textContent":"JavaScript is required"},{}],"title":"Svensk Kärnkraft. Billigare el utan gröna luftslott.","charset":"utf-8","viewport":"width=device-width, initial-scale=1","htmlAttrs":{"lang":"sv"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true